// 记录考试学阶
const RECORD_EXAM_STUDY_STEP = 'RECORD_EXAM_STUDY_STEP'
// 记录考试的类型
const RECORD_EXAM_TYPE = 'RECORD_EXAM_TYPE'
// 记录学校考试班级信息
const RECORD_EXAM_SCHOOL_CLASSINFO = 'RECORD_EXAM_SCHOOL_CLASSINFO'
// 记录学校教学班信息
const RECORD_EXAM_SCHOOL_TEACHINGCLASSINFO = 'RECORD_EXAM_SCHOOL_TEACHINGCLASSINFO'

// 组卷 新增选中的试题
const ADD_SELECTED_ITEM = 'ADD_SELECTED_ITEM'
// 组卷 移除选中的试题
const REMOVE_SELECTED_ITEM = 'REMOVE_SELECTED_ITEM'
// 组卷 清空选中的试题
const CLEAR_SELECTED_ITEM = 'CLEAR_SELECTED_ITEM'
// 组卷 清空选中的试题状态
const CLEAR_ITEM_STATUS = 'CLEAR_ITEM_STATUS'

// 填充已选择的题目到内存
const RECOVER_SELECTED_ITEMS = 'RECOVER_SELECTED_ITEMS'

// 新增试题状态对象
const ADD_ITEM_STATE = 'ADD_ITEM_STATE'
// 设置试题状态
const SET_ITEM_STATE_SELECT = 'SET_ITEM_STATE_SELECT'
// 初始化试题分数
const INIT_ITEM_SCORE = 'INIT_ITEM_SCORE'
// 设置题目分数
const SET_ITEM_SCORE = 'SET_ITEM_SCORE'
// 设置题目排序
const INIT_ITEM_SORT = 'INIT_ITEM_SORT'
// 部分排序
const SET_ITEM_SORT = 'SET_ITEM_SORT'
// 用于批量设置分值时同步分值
const SYNC_ITEM_SCORE = 'SYNC_ITEM_SCORE'

// common
const SET_LOAD = 'SET_LOAD'

// 校内角色
// 设置当前校内角色
const SET_CURRENT_POSITION = 'SET_CURRENT_POSITION'
// 初始化用户当前角色
const INIT_CURRENT_POSITION = 'init_Current_Position'
// 保存用户校内角色信息
const SAVE_SCHOOL_POSITION = 'SAVE_SCHOOL_POSITION'
// 保存用户校内角色信息
const SET_DEFAULT_POSITION = 'SET_DEFAULT_POSITION'
// 开启选择校内角色窗口
const SHOW_CHOOSE_POSITION = 'SHOW_CHOOSE_POSITION'
// 保存用户信息
const SAVE_USER_INFO = 'SAVE_USER_INFO'

export default {
  RECORD_EXAM_TYPE,
  RECORD_EXAM_STUDY_STEP,
  RECORD_EXAM_SCHOOL_CLASSINFO,
  RECORD_EXAM_SCHOOL_TEACHINGCLASSINFO,
  ADD_SELECTED_ITEM,
  REMOVE_SELECTED_ITEM,
  CLEAR_SELECTED_ITEM,
  RECOVER_SELECTED_ITEMS,
  CLEAR_ITEM_STATUS,
  ADD_ITEM_STATE,
  SET_ITEM_STATE_SELECT,
  INIT_ITEM_SCORE,
  INIT_ITEM_SORT,
  SET_ITEM_SCORE,
  SET_ITEM_SORT,
  SYNC_ITEM_SCORE,
  SET_LOAD,
  SAVE_USER_INFO,
  // 校内角色
  INIT_CURRENT_POSITION,
  SET_CURRENT_POSITION,
  SAVE_SCHOOL_POSITION,
  SET_DEFAULT_POSITION,
  SHOW_CHOOSE_POSITION
}



// WEBPACK FOOTER //
// ./src/store/mutation-type.js